import { useEffect } from 'react';
import { useToastQueueContext } from '#root/contexts/ToastContext';
import ToastContainer from '../ToastContainer/ToastContainer';

/**
 * Sistema moderno de notificaciones Toast con cola y animaciones suaves
 *
 * Características:
 * - Cola de hasta 4 toasts simultáneos con priorización
 * - Posicionamiento responsive (bottom-right desktop, top-center mobile)
 * - Duración dinámica basada en longitud del mensaje (100ms/char, min 2s, max 6s)
 * - Animaciones spring suaves (entrance/exit)
 * - Pause on hover (desktop)
 * - Priorización automática (error > warning > success > info)
 * - Diseño sutil con backdrop-filter y transparencias
 *
 * @example
 * ```tsx
 * // En App.tsx
 * import ToastNotification from '#root/components/NotificationV2/ToastNotification';
 *
 * return (
 *   <ToastQueueProvider>
 *     <RouterConfig />
 *     <ToastNotification />
 *   </ToastQueueProvider>
 * );
 * ```
 *
 * @example
 * ```javascript
 * // Testing desde Console (solo en desarrollo)
 * window.__TOAST_QUEUE__.addToast('Test message', 'success');
 * window.__TOAST_QUEUE__.addToast('Error message', 'error');
 * window.__TOAST_QUEUE__.clearAll(); // Limpiar todos los toasts
 * ```
 */
const ToastNotification = () => {
  const queue = useToastQueueContext();

  // Exponer queue globalmente en desarrollo para testing desde Console
  useEffect(() => {
    if (process.env.NODE_ENV === 'development') {
      (window as any).__TOAST_QUEUE__ = queue;
    }

    return () => {
      if (process.env.NODE_ENV === 'development') {
        delete (window as any).__TOAST_QUEUE__;
      }
    };
  }, [queue]);

  return <ToastContainer queue={queue} showProgress={false} />;
};

export default ToastNotification;
